import { ArrowDownIcon } from 'assets/icons';
import { ReactNode, useContext } from 'react';
import { AccordionContext } from './Accordion';

interface IAccordionHeader {
  className?: string;
  children?: ReactNode;
}

const AccordionHeader = ({ className, children }: IAccordionHeader) => {
  const { open, showIcon, onClick } = useContext(AccordionContext);

  return (
    <div
      className="h-14 w-full flex items-center justify-start"
      onClick={onClick}
    >
      <div className={`w-full ${className}`}>{children}</div>
      {showIcon && (
        <div
          className={`ml-auto transform transition-transform ease-linear duration-200 ${
            open ? 'rotate-180' : ''
          }`}
        >
          <ArrowDownIcon />
        </div>
      )}
    </div>
  );
};

export default AccordionHeader;
